import React, { useState } from "react";
import { Button, message, Upload } from "antd";
import "antd/dist/antd.min.css";
import { UploadOutlined } from "@ant-design/icons";
import "../ExportButton/Button.css";
import { importFile } from "../../../ImportFile/Application/ImportFile.business";

const ImportButtonElement = ({
  text,
  htmlType,
  block,
  loading: externalLoading,
  userId,
}) => {
  const [loading, setLoading] = useState(false);

  const handleImport = async (file) => {
    try {
      setLoading(true);
      
      if (!file) {
        message.error("No se ha seleccionado ningún archivo");
        return;
      }
      const isValidType = ['.json', '.xlsx', '.xls'].some(type => 
        file.name.toLowerCase().endsWith(type)
      );

      if (!isValidType) {
        message.error("Tipo de archivo no válido. Use JSON o Excel");
        return;
      }
      await importFile(userId, file);
      message.success("Archivo importado exitosamente");
    } catch (error) {
      const errorMessage = error.message || "Error al importar el archivo";
      message.error(errorMessage);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Upload
      accept=".json,.xlsx,.xls"
      beforeUpload={(file) => {
        handleImport(file);
        return false;
      }}
      showUploadList={false}
    >
      <Button
        className={"button-white-blue"}
        icon={<UploadOutlined />}
        htmlType={htmlType}
        block={block}
        loading={loading || externalLoading}
      >
        {text}
      </Button>
    </Upload>
  );
};

export default ImportButtonElement;